import { Badge, Box, Inline } from 'braid-design-system';
import type { ComponentProps } from 'react';

interface JobBadgeCommonProps {
  label: string;
  data?: ComponentProps<typeof Badge>['data'];
}
interface JobBadgeWithoutIconProps extends JobBadgeCommonProps {
  tone: ComponentProps<typeof Badge>['tone'];
}

export type JobBadgeProps = JobBadgeWithoutIconProps;

const JobBadge = ({ label, data, ...restProps }: JobBadgeProps) => (
  <Badge tone={restProps.tone} data={data}>
    {label}
  </Badge>
);

export const JobBadges = ({ badges }: { badges: JobBadgeProps[] }) =>
  badges.length ? (
    <Inline space="xxsmall">
      {badges.map((props, index) => (
        <Box key={index} pointerEvents="none">
          <JobBadge {...props} />
        </Box>
      ))}
    </Inline>
  ) : null;
